import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "flex gap-7" }
const _hoisted_2 = { class: "ml-[18px]" }
const _hoisted_3 = { class: "flex-1" }

import { Attribute } from '@/entities/attribute/types';
import { deviceGroupsQueryName } from '@/entities/device-group/hooks';
import { cloneDevice } from '@/entities/device/services';
import { ValidationRuleCollection } from '@vuelidate/core';
import {
  reactive,
  ref,
  computed,
  provide,
  watch,
  PropType,
  Ref,
} from 'vue';
import { set, cloneDeep } from 'lodash';
import { minValue, required } from '@vuelidate/validators';

import { useForm } from '@/core/hooks/forms';
import { useCreateDeviceMutation } from '@/entities/device/hooks';
import { useGetTypeQuery } from '@/entities/type/hooks';

import { Type } from '@/entities/type/types';
import { Device } from '@/entities/device/types';

import DeviceModelFormPart from '@/entities/device/components/form/DeviceModelFormPart.vue';
import DeviceFormTree from '@/entities/device/components/form/DeviceFormTree.vue';

import {
  NkStack,
  NkForm,
  NkButton,
  NkGroup,
} from '@/core/components';
import { useQueryClient } from 'vue-query';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceCreateForm',
  props: {
  parent: {
    type: Number as PropType<Device['id']>,
    default: null,
  },
  typeId: {
    type: Number as PropType<Type['id']>,
    required: true,
  },
  deviceGroup: {
    type: Number as PropType<Device['deviceGroup']>,
    default: null,
  },
},
  emits: [],
  setup(__props, { emit }) {

const props = __props


const { onSubmitted } = useForm(emit);



const queryClient = useQueryClient();

const getTypeId = computed(() => props.typeId);

const form = ref();
const deviceFields = reactive({} as unknown as Device);
const attributes = ref<Attribute[]>([]);

const {
  mutateAsync,
  isError,
  isLoading,
  error,
} = useCreateDeviceMutation();

const selectedFieldsPath = ref('');

const setSelectedFieldsPath = (fieldPath: string) => {
  selectedFieldsPath.value = fieldPath;
};

watch(deviceFields, () => {
  if (Object.prototype.hasOwnProperty.call(deviceFields, 'deviceGroup')) {
    deviceFields.deviceGroup = props.deviceGroup;
  }

  if (props.parent && Object.prototype.hasOwnProperty.call(deviceFields, 'parent')) {
    deviceFields.parent = props.parent;
  }
});

const rules = reactive({});

const setAttribute = (attribute: Attribute) => {
  if (!attributes.value.map(o => o.id).includes(attribute.id)) {
    attributes.value.push(attribute);
  }
};

const generateRules = (device: Device, _rules: any = {}) => {
  const deviceClone = cloneDeep(device);

  Object.entries(deviceClone.deviceValues).forEach(([key, value]) => {
    const attribute = attributes.value.find((i) => i.id === value.attributeId);
    const rule: ValidationRuleCollection = {};

    if (attribute && attribute.isRequired) {
      rule.required = required;
    }

    if (attribute && ['float', 'int'].includes((attribute.attributType))) {
      rule.minValue = minValue(1);
    }

    set(_rules, `deviceValues.${ key }`, {
      value: rule,
    });
  });

  if (deviceClone.subDevices) {
    // eslint-disable-next-line no-param-reassign
    _rules.subDevices = [...[...Array(deviceClone.subDevices.length)].map(() => ({}))];

    deviceClone.subDevices.forEach((_, i) => {
      generateRules(deviceClone.subDevices[i] as unknown as Device, _rules.subDevices[i]);
    });
  }
  return _rules;
};

const submit = async() => {
  await Object.assign(rules, generateRules(deviceFields));

  if (!isLoading.value) {
    form.value.validator.$validate().then((valid: boolean) => {
      if (valid) {
        mutateAsync(
          deviceFields, {
            onSuccess: () => {
              queryClient.refetchQueries([deviceGroupsQueryName, { id: props.deviceGroup }], {active: true});
            },
          },
        ).then((data) => {
          onSubmitted(data);
        });
      }
    });
  }
};

provide('deviceForm', {
  deviceGroup: props.deviceGroup,
  selectedFieldsPath,
  setSelectedFieldsPath,
  setAttribute,
});

return (_ctx: any,_cache: any) => {
  const _component_ElAlert = _resolveComponent("ElAlert")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_unref(NkForm), {
    ref_key: "form",
    ref: form,
    fields: deviceFields,
    rules: rules
  }, _createSlots({
    footer: _withCtx(() => [
      _createVNode(_unref(NkGroup), { position: "right" }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_unref(NkButton), {
            icon: "NkInput",
            type: "success",
            onClick: _withModifiers(submit, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('device.action.add')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])), [
            [_directive_loading, _unref(isLoading)]
          ])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(DeviceFormTree, {
            type: _unref(getTypeId),
            fields: deviceFields
          }, null, 8, ["type", "fields"])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(DeviceModelFormPart, {
            type: _unref(getTypeId),
            fields: deviceFields
          }, null, 8, ["type", "fields"])
        ])), [
          [_directive_loading, _unref(isLoading)]
        ])
      ])
    ]),
    _: 2
  }, [
    (_unref(isError))
      ? {
          name: "header",
          fn: _withCtx(() => [
            _withDirectives(_createVNode(_component_ElAlert, {
              type: "error",
              "show-icon": ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(error)?.response?.data?.message || _unref(error)), 1)
              ]),
              _: 1
            }, 512), [
              [_vShow, _unref(isError)]
            ])
          ])
        }
      : undefined
  ]), 1032, ["fields", "rules"])), [
    [_directive_loading, _unref(isLoading)]
  ])
}
}

})